import React, { useState, useEffect } from "react";
import Sidebar from "./Sidebar";

const Home = () => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
  }, []);

  return (
    <div style={{ display: "flex", minHeight: "100vh" }}>
      {/* Sidebar */}
      <Sidebar user={user} setUser={setUser} />

      {/* Main Content */}
      <div style={{ flex: 1, padding: "20px" }}>
        <h1 style={{ textAlign: "center", color: "#2c3e50" }}>
          SRI SIDHI VINAYAKAA DEVELOPERS
        </h1>
        <h3 style={{ textAlign: "center", color: "#b11919ff" }}> Greatway for a better future</h3>

        {/* Images Section */}
        <div
  style={{
    marginTop: "30px",
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
    gap: "20px",
    justifyItems: "center", // centers horizontally
    alignItems: "center",   // centers vertically
  }}
>
  <img src="/image.png" alt="Gallery 1" style={styles.image} />
</div>

      </div>
    </div>
  );
};

const styles = {
  container: {
      display: "flex",
      justifyContent: "center", // centers horizontally
      alignItems: "center",     // centers vertically
      height: "100vh",          // full viewport height
    },
  image: {
  width: "100%",
  height: "100vh",        // full viewport height
  objectFit: "cover",     // crop image to fit
  borderRadius: "0px",   // no rounding, so it covers edges
  boxShadow: "none",      // remove shadow for fullscreen
},
};

export default Home;
